import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import cn from 'classnames';
import { Box } from './Box';
import styles from './Layout.module.scss';
export const Row = /*#__PURE__*/ forwardRef((_0, _1)=>{
    let _ref = [
        _0,
        _1
    ], [_ref1, ..._rest] = _ref, { className, children } = _ref1, rest = _object_without_properties(_ref1, [
        "className",
        "children"
    ]), [ref] = _rest;
    return /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
        ref: ref,
        className: cn(styles.row, className)
    }, rest), {
        children: children
    }));
});
Row.displayName = 'Row';
